module.exports = __webpack_public_path__ + "img/logo_spmv_branca.a2cd6303.png";